export const GP_CONSENT_TEMPLATE_ID = '65a54152c4435de2ecef3885'

/** GP Connect form: either the canonical master (`id`) or a per-home copy (`parentConsentTemplate`). */
export function isGpConnectConsentTemplate(template: {
  id: string
  parentConsentTemplate?: string
}): boolean {
  return (
    template.id === GP_CONSENT_TEMPLATE_ID ||
    template.parentConsentTemplate === GP_CONSENT_TEMPLATE_ID
  )
}
